import React from 'react';
import { Helmet } from 'react-helmet';

import { getCTATag } from 'services/mix-and-match';
import { getCatalogSku, getRealSku } from 'services/product';
import { SelectedProductAttributes } from 'types/ProductPageV2/Products';

export default function CTATagScript({
  productAttributes,
}: {
  productAttributes: SelectedProductAttributes;
}): JSX.Element {
  return (
    <Helmet>
      <script type="text/javascript">
        {getCTATag(
          '',
          getCatalogSku(productAttributes),
          getRealSku(productAttributes)
        )}
      </script>
    </Helmet>
  );
}
